module.exports = __webpack_public_path__ + "static/media/detail.d19527f9.png";